var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    id: "master_svg0_2751_01146"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000000",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.28571581840515%",
    stopColor: "#000000",
    stopOpacity: 0.10000000149011612
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,2.12389C11.2566,2.12389,13.8761,4.74336,13.8761,8C13.8761,11.2566,11.2566,13.8761,8,13.8761C4.74336,13.8761,2.12389,11.2566,2.12389,8C2.12389,4.74336,4.74336,2.12389,8,2.12389ZM8,0C3.61062,0,0,3.61062,0,8C0,12.3894,3.61062,16,8,16C12.3894,16,16,12.3894,16,8C16,3.61062,12.3894,0,8,0Z",
    fill: "url(#master_svg0_2751_01146)",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLoading);
export default __webpack_public_path__ + "static/media/black_loading.6a6a9eb90fa22c81920176d472f8bef1.svg";
export { ForwardRef as ReactComponent };